import { connect } from 'react-redux';
import { HomeSummaryComponent } from './view';

const mapStateToProps = (state: any) => ({
  stepsApStore: state.quotationApState
});
//   const mapDispatchToProps = {};

export const HomeSummary = connect(mapStateToProps)(HomeSummaryComponent);
